import { useTranslation } from 'react-i18next'

import {
  QA_NAME_LISTING_PHOTO_MOSAIC_MORE,
  QA_NAME_LISTING_PHOTO_MOSAIC_TILE,
} from '../RentalPortalListingPhotoMosaic.constants'
import {
  getIsListingMosaicAddCell,
  getIsListingMosaicPhotoCell,
} from '../RentalPortalListingPhotoMosaic.utils'
import { RentalPortalListingPhotoMosaicAddTile } from '../RentalPortalListingPhotoMosaicAddTile'
import { RentalPortalListingPhotoMosaicTile } from '../RentalPortalListingPhotoMosaicTile'

import * as styles from '../RentalPortalListingPhotoMosaic.module.css'

function RentalPortalListingPhotoMosaicCell({
  cell,
  onAdd,
  onClickMore,
  onClickThumbnail,
}) {
  const { t } = useTranslation()

  return getIsListingMosaicPhotoCell(cell) ? (
    <RentalPortalListingPhotoMosaicTile
      className={styles.gridTile}
      moreCount={cell.moreCount}
      photo={cell.photo}
      qaName={
        cell.moreCount
          ? QA_NAME_LISTING_PHOTO_MOSAIC_MORE
          : QA_NAME_LISTING_PHOTO_MOSAIC_TILE
      }
      tooltip={cell.moreCount ? t('RentalPortal.ListingPhotoOpenKey') : null}
      onClick={cell.moreCount ? onClickMore : onClickThumbnail}
    />
  ) : getIsListingMosaicAddCell(cell) ? (
    <RentalPortalListingPhotoMosaicAddTile
      isWide={cell.isWide}
      onClick={onAdd}
    />
  ) : (
    <div className={styles.emptyCell} />
  )
}

export default RentalPortalListingPhotoMosaicCell
